import { SVGProps } from 'react';

const CircleArrowOutDownLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M2 12a10 10 0 1 1 10 10M2 22l10-10M2 16v6h6"
    />
  </svg>
);
export default CircleArrowOutDownLeft;
